import { Injectable } from '@angular/core';
import {environment} from "@environments/environment";
import {HttpClient} from "@angular/common/http";
import {RestApiManager} from "./rest-api-manager";
import {AccountManagerService} from "./account-manager-service";

@Injectable({
  providedIn: 'root'
})
export class NotificationManagerService {

  constructor(
    private httpClient: HttpClient,
    private restApiManager: RestApiManager,
    private accountManagerService: AccountManagerService,
  ) { }

  async sendNotification(title: string, description: string, uid: string, data: any) {
    return this.restApiManager.post(
      `${environment.restApi.endpoint}/notifications`,
      {
        uid,
        title,
        description,
        data
      },
      this.accountManagerService.account.authToken
    );
  }

  async sendNotificationFCM(title: string, body: string, fcmToken: string, dataToSend: any) {
    const data = {
      "notification": {
        "title": title,
        "body": body
      },
      "data": dataToSend,
      "to": fcmToken,
    };
    return await this.httpClient.post('https://fcm.googleapis.com/fcm/send', JSON.stringify(data), {
      headers: {
        'Authorization': 'key=' + environment.firebaseMessagingKey,
        'Content-Type': 'application/json',
      }
    }).toPromise();
  }

}
